<template>
  <div style="width: 100%;">
    <el-header  style="margin: 15px" >
      <breadcrumb></breadcrumb>
    </el-header>

      <el-main style="overflow-x: hidden;">
        <el-form ref="form" label-width="200px" @submit.native.prevent >
          <el-row>
            <el-col :span="12">
              <el-form-item :label="$t('field.searchCustomer')">
                <el-input v-model="condition"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item :label="$t('field.onlyQuerySampleCust')" label-width="270px" >
                <el-checkbox  v-model="checkbox"></el-checkbox>     
              </el-form-item>
            </el-col>             
          </el-row>   
          <el-row>
            <el-col :span="24" style="text-align:center">
              <el-button type="primary" @click="search"  size="small">{{$t('button.search')}}</el-button>
              <el-button type="success" @click="create"  size="small">{{$t('button.create')}}</el-button>
            </el-col>             
          </el-row>   
        </el-form>
        <el-row >  
          <Table :tableData="tableData" :linkAction="linkAction"  @reload-data-by-sort="reloadDataBySort"/> 
        </el-row>
        
    </el-main>
  </div>
</template>

<script>
import Table from '../components/FuzzySearchTableWithRemoteSort'
import Breadcrumb from '../components/Breadcrumb'
import { apiFindCustList } from "../../utils/api.js";
import authHeader from "../../services/auth-header";


export default {
  name: 'customerManagement',
  data() {    
    return {     
      condition: '',
      checkbox:false,
      sortColumn:'',
      sortType:'',
      tableData: {
        columns: [
          { field: "sapCode", title: this.$i18n.t('field.customerNo'), width: 140, link:true, align:'center'},         
          { field: "customerNameC", title: this.$i18n.t('field.customerNameC'), width: 260 },
          { field: "customerNameE", title: this.$i18n.t('field.customerNameE'), width: 260  },
          { field: "sortl", title: this.$i18n.t('field.sortl'), width: 260 },
          { field: "address", title: this.$i18n.t('field.companyAddress'), width: 260},       
          { field: "telf1", title: this.$i18n.t('field.companyPhone'), width: 200 },
          { field: "country", title: this.$i18n.t('field.country'),align:'center', width: 200 },
          { field: "fae", title: 'INCX FAE', width: 180 },
          { field: "rmaShortCode", title: this.$i18n.t('field.rmaShortCode'), align:'center', width: 180 },
          { field: "bzirk", title: this.$i18n.t('field.bzirk'), align:'center', width: 180 }
        ],
        originalTableData:[],
        data: [],
        pagesize: 10,
        currentPage: 1,
        tableId:'custTable',
        exportName: this.$i18n.t('menu.customerManagement')
      }     
    };
  },   
  components: {
    Breadcrumb,
    Table
  },
  mounted() {  
    this.findData('', false)
    
  },
  methods: {
    findData(condition, checkbox){
      apiFindCustList({ headers: authHeader(), condition:condition, checkbox:checkbox, sortColumn: this.sortColumn, sortType:this.sortType}).then((response) => { 
        this.tableData.data = response.data;  
        this.tableData.originalTableData =  this.tableData.data;        
      }).catch((err) => {
        console.log(err);
      });
    },
    search() {
      this.findData(this.condition, this.checkbox);
    }, 
    create() {
      //this.$router.push("/editCustomer");
      const { href } = this.$router.resolve("/editCustomer");
      window.open(href, '_blank');
    },    
    linkAction(row, index){      
      //this.$router.push("/editCustomer/" + row.id);
      const { href } = this.$router.resolve("/editCustomer/" + row.id );
      window.open(href, '_blank');
      
    },
    reloadDataBySort(sortColumn, sortType){
      this.sortColumn = sortColumn;
      this.sortType = sortType;
      this.findData()
    } 
  }
};
</script>
